const RE_CANONICAL_ID = /^[a-f0-9]{24}$/;
const RE_HASH = /^[a-f0-9]{64}$/;
const REVENUE_SNAPSHOT_WAIT_MS = 3000;
const REVENUE_STORAGE_PREFIX = 'elal_ga4_revenue:';
const seenRevenueEvents = new Set();
const nonnegative = (value) => Number.isFinite(value) && value >= 0;

const isElalWebRevenueEnabled = (isElal, userAgent = typeof navigator === 'undefined' ? '' : navigator.userAgent) =>
    isElal === true && !userAgent.includes('ElalMobile');

const isValidRevenueSnapshot = (snapshot) => !!snapshot
    && RE_CANONICAL_ID.test(snapshot.reservation_id)
    && typeof snapshot.transaction_id === 'string' && !!snapshot.transaction_id.trim()
    && snapshot.currency === 'USD'
    && ['value', 'usd_to_pay', 'points_spent', 'points_cash_value', 'voucher_cash_value', 'item_price'].every((key) => nonnegative(snapshot[key]))
    && (snapshot.order_points_value === 'NA' || nonnegative(snapshot.order_points_value))
    && Math.abs(snapshot.value - snapshot.usd_to_pay - snapshot.points_cash_value - snapshot.voucher_cash_value) < 0.011;

const sanitizedHash = (value) => typeof value === 'string' && RE_HASH.test(value) ? value : 'NA';

const withAnalyticsDeadline = async (read) => {
    let timer;
    try {
        return await Promise.race([
            Promise.resolve().then(read).catch(() => null),
            new Promise((resolve) => { timer = setTimeout(() => resolve(null), REVENUE_SNAPSHOT_WAIT_MS); }),
        ]);
    } finally {
        clearTimeout(timer);
    }
};

const loadElalBookingAnalytics = async (bookingId, fetchBookings, isElal) => {
    if (!isElalWebRevenueEnabled(isElal) || typeof bookingId !== 'string' || !RE_CANONICAL_ID.test(bookingId)) return null;
    const response = await withAnalyticsDeadline(fetchBookings);
    const booking = response?.bookings?.length === 1 ? response.bookings[0] : null;
    const snapshot = booking?.analytics_context;
    return booking?.id === bookingId && snapshot?.reservation_id === bookingId && isValidRevenueSnapshot(snapshot)
        ? snapshot : null;
};

const claimRevenueEvent = (eventName, reservationId) => {
    const key = `${REVENUE_STORAGE_PREFIX}${eventName}:${reservationId}`;
    if (seenRevenueEvents.has(key)) return false;
    try {
        if (typeof window !== 'undefined' && window.sessionStorage.getItem(key)) {
            seenRevenueEvents.add(key);
            return false;
        }
        if (typeof window !== 'undefined') window.sessionStorage.setItem(key, '1');
    } catch (_err) {
        // Blocked session storage still has page-lifetime deduplication.
    }
    seenRevenueEvents.add(key);
    return true;
};

module.exports = {
    REVENUE_SNAPSHOT_WAIT_MS,
    isElalWebRevenueEnabled,
    isValidRevenueSnapshot,
    sanitizedHash,
    withAnalyticsDeadline,
    loadElalBookingAnalytics,
    claimRevenueEvent,
};
